/* global $ */

import jump from 'jump.js';

const $main = $('#main');

const offerConnect = {
  initialize() {
    $main.on('click', '.btn[href*="/offerte-aanvragen"]', (e) => {
      const $nearbyOfferForm = $main.find('.js-offer-form');

      if ($nearbyOfferForm.length) {
        e.preventDefault();

        this.jumpToElement($nearbyOfferForm.get(0));
      }
    });
  },

  jumpToElement(element) {
    const navbarHeight = $('.navbar-sticky-wrap').height();

    jump(element, {
      offset: navbarHeight * -1,
    });
  },
};

export default offerConnect;
